import { LogoMark } from "./Logo";

export default function Footer() {
    return (
        <footer className="bg-ink pb-10 pt-16 text-cream/80">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
                    <div>
                        <div className="flex items-center gap-2.5">
                            <LogoMark />
                            <span className="font-display text-xl font-extrabold tracking-tight text-cream">
                                Fall Safe Ready
                            </span>
                        </div>
                        <p className="mt-5 text-lg text-cream">Arlington, Virginia</p>
                        <a
                            href="mailto:SarahGmyr@gmail.com"
                            data-testid="footer-email"
                            className="mt-1 inline-block text-lg font-semibold text-cream underline decoration-brand-amber decoration-2 underline-offset-4 transition-colors duration-200 hover:text-brand-amber"
                        >
                            SarahGmyr@gmail.com
                        </a>
                    </div>
                    <div className="max-w-xl text-lg leading-relaxed text-cream/90">
                        <p>
                            Fall Safe Ready classes are educational and are not medical treatment. Talk with your
                            doctor before starting a new exercise program.
                        </p>
                        <p className="mt-3">Statistics: CDC and the National Council on Aging.</p>
                    </div>
                </div>
                <div className="mt-12 border-t border-cream/15 pt-6">
                    <p className="text-base text-cream/80">© 2026 Fall Safe Ready</p>
                </div>
            </div>
        </footer>
    );
}